<template>
    <div class="resource_main">
        <!-- <div style="text-align:left;"><p
        style="margin-top:20px;font-weight:bold;font-size=16px;color:#606266;">对于以下激励资源，请填写您上级的使用频率：
        </p></div>     -->
        <el-table
        :data="resource_info"
        :empty-text="emptyText"
        border
        style="width:100%;border-radius:5px;"
        :span-method="objectSpanMethod">
            <el-table-column
                prop="display_num"
                label="序号"
                min-width="6%">
            </el-table-column>
            <el-table-column
                prop="incentive_class"
                label="激励分类"
                min-width="12%">
            </el-table-column>
            <el-table-column
                prop="incentive_subclass"
                label="激励子分类"
                min-width="10%">
            </el-table-column>
            <el-table-column
                prop="sample"
                label="示例"
                min-width="38%">
                <template slot-scope="scope">
                    <template v-for="(item, index) in scope.row.sample">
                        <span :key="index">{{ item }}</span>
                        <br :key="index">
                    </template>
                </template>
            </el-table-column>
            <el-table-column
                prop="used_freq"
                label="使用频率"
                min-width="35%">
                <template slot-scope="scope">
                    <el-radio-group v-model="scope.row.freq">
                        <el-radio :label="1" :disabled="is_view" v-if="(!scope.row.freq && error_flag_resource)" style="color:red;">经常使用</el-radio>
                        <el-radio :label="1" :disabled="is_view" v-else>经常使用</el-radio>
                        <el-radio :label="2" :disabled="is_view" v-if="(!scope.row.freq && error_flag_resource)" style="color:red;">偶尔使用</el-radio>
                        <el-radio :label="2" :disabled="is_view" v-else>偶尔使用</el-radio>
                        <el-radio :label="3" :disabled="is_view" v-if="(!scope.row.freq && error_flag_resource)" style="color:red;">从不使用</el-radio>
                        <el-radio :label="3" :disabled="is_view" v-else>从不使用</el-radio>
                    </el-radio-group>
                </template>
            </el-table-column>
        </el-table>
    </div>   
</template>

<script>
import postdata from "@/api/postData.js";
// import getdata from "@/api/getData.js";
export default {
    // 组件传递的prop数据，会在beforeUpdate钩子期间生效！
    // beforeUpdate() {
    //     if(this.question_info.length <= 0){
    //         this.display_flag = true;
    //     }else{
    //         // 这里要增加else的处理，在导入模板后更新display_flag的值，因为没有重新加载页面，所以此时的display_flag不会从重置为初始值false开始判断
    //         this.display_flag = false;
    //     }
    // },
    data() {
        return {
            template_file: {
                file_name: 'incentive-resource_template.xlsx'
            },
            formInline: {
                search_info: '',
                search_result: [],
            },
            display_flag: false,
            emptyText: '暂无激励资源信息，请先导入。',
            columnOrder: ['incentive_class'],
        }
    },
    props: ['resource_info', 'error_flag_resource', "is_view"],
    methods: {
        // 执行单元格合并
        objectSpanMethod({ row, column, rowIndex, columnIndex }){					
            // let obj = {
            //     rowspan: row[this.columnOrder[columnIndex]].RowSpan,
            //     colspan: row[this.columnOrder[columnIndex]].ColumnSpan
            // }
            // console.log(column, rowIndex, columnIndex);
            // return obj;
            if(columnIndex==1){
                return [row.RowSpan, row.ColumnSpan];
            }
        },
        Download_template() {
            postdata.downloadFiles("download", JSON.stringify(this.template_file))
              .then(resp => {
                // 将流文件通过浏览器下载，这里使用整个后台返回的response，供download函数提取data、headers等信息
                this.download(resp);
              })
              .catch(err => {
                console.log(err);
              })
        },
        download (res) {
            let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });//type是文件类，详情可以参阅blob文件类型
            // 创建新的URL并指向File对象或者Blob对象的地址
            const blobURL = window.URL.createObjectURL(blob)
            // 创建a标签，用于跳转至下载链接
            const tempLink = document.createElement('a')
            tempLink.style.display = 'none'
            tempLink.href = blobURL
            tempLink.setAttribute('download', decodeURI(res.headers['content-disposition'].split(';')[1].split('=')[1]))
            // 兼容：某些浏览器不支持HTML5的download属性
            if (typeof tempLink.download === 'undefined') {
                tempLink.setAttribute('target', '_blank')
            }
            // 挂载a标签
            document.body.appendChild(tempLink)
            tempLink.click()
            document.body.removeChild(tempLink)
            // 释放blob URL地址
            window.URL.revokeObjectURL(blobURL)
        },
        // 向父组件传递问卷测评结果
        submitResource() {
            this.$emit('sendData', [this.resource_info, 'submit']);
        },
        saveResource() {
            this.$emit('sendData', [this.resource_info, 'save']);
        },
    }
}
</script>

<style scoped>
.el-table /deep/ th.el-table__cell {
    background-color: #f5f7fa;
}
.resource_main {
    padding: 20px;
}
.resource_main /deep/ .el-table__header {
    font-size: 14px;
}
</style>